import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Naming the Fear",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I don’t force myself to decide. I simply admit: I’m afraid to leave."
    ],
      [
      "Daily intention: Today I don’t force myself to decide. I simply admit: I’m afraid to leave."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One slow breath.",
      "I tell myself quietly: “This fear is here to protect me, not to control me.”"
    ],
      [
      "I pause with myself.",
      "One slow breath.",
      "I tell myself quietly: “This fear is here to protect me, not to control me.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What exactly scares me about leaving?\n[Write here]",
      "What do I tell myself to avoid touching this fear?\n[Write here]",
      "Where do I feel this fear in my body right now?\n[Write here]"
    ],
      [
      "What exactly scares me about leaving?\n[Write here]",
      "What do I tell myself to avoid touching this fear?\n[Write here]",
      "Where do I feel this fear in my body right now?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Fear has a voice. Today I listen without obeying it."
    ],
      [
      "Closing",
      "Fear has a voice. Today I listen without obeying it."
    ]
    ),
    action: localizedGenderNode(
      "When thoughts of leaving arise — one breath + the sentence: “I’m only listening right now.”",
      "When thoughts of leaving arise — one breath + the sentence: “I’m only listening right now.”"
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "What Isn’t Good (Without Justifying)",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I see reality as it is, without softening or exaggerating."
    ],
      [
      "Daily intention: Today I see reality as it is, without softening or exaggerating."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “Truth doesn’t need drama.”"
    ],
      [
      "I pause with myself.",
      "One breath. “Truth doesn’t need drama.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Three things that are not good for me in this relationship:\n[Write here]",
      "How does each one affect me emotionally?\n[Write here]",
      "What do I gain by minimizing this?\n[Write here]"
    ],
      [
      "Three things that are not good for me in this relationship:\n[Write here]",
      "How does each one affect me emotionally?\n[Write here]",
      "What do I gain by minimizing this?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Seeing truth is not betrayal. It is self-respect."
    ],
      [
      "Closing",
      "Seeing truth is not betrayal. It is self-respect."
    ]
    ),
    action: localizedGenderNode(
      "Today I don’t justify one behavior that hurts me (I just notice it).",
      "Today I don’t justify one behavior that hurts me (I just notice it)."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "What Keeps Me There",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I explore not what’s bad — but what keeps me."
    ],
      [
      "Daily intention: Today I explore not what’s bad — but what keeps me."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What keeps me staying? (fear of being alone / hope / guilt / habit / dependency)\n[Write here]",
      "What am I afraid will happen if I leave?\n[Write here]",
      "Which part of me needs safety right now?\n[Write here]"
    ],
      [
      "What keeps me staying? (fear of being alone / hope / guilt / habit / dependency)\n[Write here]",
      "What am I afraid will happen if I leave?\n[Write here]",
      "Which part of me needs safety right now?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "If something holds me — it deserves to be seen."
    ],
      [
      "Closing",
      "If something holds me — it deserves to be seen."
    ]
    ),
    action: localizedGenderNode(
      "I name one thing that holds me — without judgment.",
      "I name one thing that holds me — without judgment."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Fear of Being Alone",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I touch the fear without running from it."
    ],
      [
      "Daily intention: Today I touch the fear without running from it."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “Loneliness is a feeling, not a life sentence.”"
    ],
      [
      "I pause with myself.",
      "One breath. “Loneliness is a feeling, not a life sentence.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is my scariest image of being alone?\n[Write here]",
      "When have I been alone before — and survived?\n[Write here]",
      "What gentle truth exists even if the fear is strong?\n[Write here]"
    ],
      [
      "What is my scariest image of being alone?\n[Write here]",
      "When have I been alone before — and survived?\n[Write here]",
      "What gentle truth exists even if the fear is strong?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Fear never tells the whole story."
    ],
      [
      "Closing",
      "Fear never tells the whole story."
    ]
    ),
    action: localizedGenderNode(
      "5 minutes of conscious alone time (no screen) — just being.",
      "5 minutes of conscious alone time (no screen) — just being."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "Guilt vs. Responsibility",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I separate guilt from responsibility."
    ],
      [
      "Daily intention: Today I separate guilt from responsibility."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What do I feel guilty about when I think of leaving?\n[Write here]",
      "What is truly my responsibility — and what is not?\n[Write here]",
      "What does responsibility look like without self-punishment?\n[Write here]"
    ],
      [
      "What do I feel guilty about when I think of leaving?\n[Write here]",
      "What is truly my responsibility — and what is not?\n[Write here]",
      "What does responsibility look like without self-punishment?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Responsibility does not require self-sacrifice."
    ],
      [
      "Closing",
      "Responsibility does not require self-sacrifice."
    ]
    ),
    action: localizedGenderNode(
      "When guilt appears — I say: “This is a feeling, not a verdict.”",
      "When guilt appears — I say: “This is a feeling, not a verdict.”"
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Hope That Doesn’t Change",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I examine whether I’m living on an imagined future."
    ],
      [
      "Daily intention: Today I examine whether I’m living on an imagined future."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What change have I been waiting for a long time?\n[Write here]",
      "What has reality shown me so far?\n[Write here]",
      "How does my body feel holding hope that doesn’t come true?\n[Write here]"
    ],
      [
      "What change have I been waiting for a long time?\n[Write here]",
      "What has reality shown me so far?\n[Write here]",
      "How does my body feel holding hope that doesn’t come true?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Hope that doesn’t move drains energy."
    ],
      [
      "Closing",
      "Hope that doesn’t move drains energy."
    ]
    ),
    action: localizedGenderNode(
      "Today I notice the difference between what is happening and what I wish would happen.",
      "Today I notice the difference between what is happening and what I wish would happen."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "My Worth Inside the Relationship",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I check how this relationship affects my self-worth."
    ],
      [
      "Daily intention: Today I check how this relationship affects my self-worth."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "How do I feel about myself inside this relationship?\n[Write here]",
      "What happens to my confidence during conflict?\n[Write here]",
      "Which version of me wants more respect?\n[Write here]"
    ],
      [
      "How do I feel about myself inside this relationship?\n[Write here]",
      "What happens to my confidence during conflict?\n[Write here]",
      "Which version of me wants more respect?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "A relationship should not shrink me."
    ],
      [
      "Closing",
      "A relationship should not shrink me."
    ]
    ),
    action: localizedGenderNode(
      "One sentence of self-respect I carry with me today.",
      "One sentence of self-respect I carry with me today."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "What My Body Already Knows",
    opening: localizedGenderNode(
      [
      "Daily intention: My body knows before my mind."
    ],
      [
      "Daily intention: My body knows before my mind."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One slow breath."
    ],
      [
      "I pause with myself.",
      "One slow breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "How does my body react when I imagine staying?\n[Write here]",
      "How does my body react when I imagine leaving?\n[Write here]",
      "What’s the difference?\n[Write here]"
    ],
      [
      "How does my body react when I imagine staying?\n[Write here]",
      "How does my body react when I imagine leaving?\n[Write here]",
      "What’s the difference?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "The body doesn’t lie — it signals."
    ],
      [
      "Closing",
      "The body doesn’t lie — it signals."
    ]
    ),
    action: localizedGenderNode(
      "Hand on chest/belly + one breath when confusion arises.",
      "Hand on chest/belly + one breath when confusion arises."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Fear of Making a Mistake",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I release the need for a perfect decision."
    ],
      [
      "Daily intention: Today I release the need for a perfect decision."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What am I afraid of getting wrong?\n[Write here]",
      "Is not choosing also a choice?\n[Write here]",
      "What is the cost of staying without choosing?\n[Write here]"
    ],
      [
      "What am I afraid of getting wrong?\n[Write here]",
      "Is not choosing also a choice?\n[Write here]",
      "What is the cost of staying without choosing?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "There is no decision without risk — but there is truth."
    ],
      [
      "Closing",
      "There is no decision without risk — but there is truth."
    ]
    ),
    action: localizedGenderNode(
      "Today I stop demanding certainty from myself.",
      "Today I stop demanding certainty from myself."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Missing Boundaries",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I see where I have no boundaries."
    ],
      [
      "Daily intention: Today I see where I have no boundaries."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Where do I repeatedly give myself up?\n[Write here]",
      "What boundary would I like to set — but haven’t?\n[Write here]",
      "What fear surrounds this boundary?\n[Write here]"
    ],
      [
      "Where do I repeatedly give myself up?\n[Write here]",
      "What boundary would I like to set — but haven’t?\n[Write here]",
      "What fear surrounds this boundary?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Without boundaries — fear grows."
    ],
      [
      "Closing",
      "Without boundaries — fear grows."
    ]
    ),
    action: localizedGenderNode(
      "One small inner boundary just for me (even without saying it).",
      "One small inner boundary just for me (even without saying it)."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Who I Am Without the Relationship",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I remember I am more than this relationship."
    ],
      [
      "Daily intention: Today I remember I am more than this relationship."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Who was I before this relationship?\n[Write here]",
      "Which part of me faded over time?\n[Write here]",
      "What do I miss about myself?\n[Write here]"
    ],
      [
      "Who was I before this relationship?\n[Write here]",
      "Which part of me faded over time?\n[Write here]",
      "What do I miss about myself?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "I do not disappear without a relationship."
    ],
      [
      "Closing",
      "I do not disappear without a relationship."
    ]
    ),
    action: localizedGenderNode(
      "One action that reconnects me only to myself.",
      "One action that reconnects me only to myself."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "An Honest Inner Conversation",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I speak honestly with myself."
    ],
      [
      "Daily intention: Today I speak honestly with myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "If I weren’t afraid — what would I admit to myself?\n[Write here]",
      "What do I need most right now?\n[Write here]",
      "What am I no longer willing to keep paying?\n[Write here]"
    ],
      [
      "If I weren’t afraid — what would I admit to myself?\n[Write here]",
      "What do I need most right now?\n[Write here]",
      "What am I no longer willing to keep paying?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Truth doesn’t shout. It whispers."
    ],
      [
      "Closing",
      "Truth doesn’t shout. It whispers."
    ]
    ),
    action: localizedGenderNode(
      "I allow truth to exist without acting on it.",
      "I allow truth to exist without acting on it."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Where I’m Going",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I look forward — not to escape, but to orient."
    ],
      [
      "Daily intention: Today I look forward — not to escape, but to orient."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "How do I want to feel in a future relationship?\n[Write here]",
      "Which value am I no longer willing to give up?\n[Write here]",
      "What one small step moves me closer?\n[Write here]"
    ],
      [
      "How do I want to feel in a future relationship?\n[Write here]",
      "Which value am I no longer willing to give up?\n[Write here]",
      "What one small step moves me closer?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Direction begins with intention, not decision."
    ],
      [
      "Closing",
      "Direction begins with intention, not decision."
    ]
    ),
    action: localizedGenderNode(
      "I write one value and hold it this week.",
      "I write one value and hold it this week."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Gentle Closure (Staying Loyal to Myself)",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I choose myself — even without a final decision."
    ],
      [
      "Daily intention: Today I choose myself — even without a final decision."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One slow breath."
    ],
      [
      "I pause with myself.",
      "One slow breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What did I learn about myself on this journey?\n[Write here]",
      "What is clearer to me now, even if it hurts?\n[Write here]",
      "A return sentence for days of confusion:\n[Write here]"
    ],
      [
      "What did I learn about myself on this journey?\n[Write here]",
      "What is clearer to me now, even if it hurts?\n[Write here]",
      "A return sentence for days of confusion:\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Final closure of the journey",
      "I don’t have to know everything right now.",
      "But I do know one thing:",
      "I deserve a relationship that doesn’t scare me into disappearing.",
      "And that is strength."
    ],
      [
      "Final closure of the journey",
      "I don’t have to know everything right now.",
      "But I do know one thing:",
      "I deserve a relationship that doesn’t scare me into disappearing.",
      "And that is strength."
    ]
    ),
    action: localizedGenderNode(
      "One action that honors me — here and now.",
      "One action that honors me — here and now."
    ),
  },
].map(buildNormalizedDay);

export const fearLeavingBadRelationshipBlueprintEn = buildNormalizedPilotBlueprint({
  id: "fear_leaving_bad_relationship_14d",
  version: "tri_locale_emit_en_v1",
  durationDays: 14,
  problemKey: "fear_leaving_bad_relationship",
  category: "general",
  journeyName: {
    he: "פחד לעזוב קשר לא טוב",
    en: "Fear of Leaving an Unhealthy Relationship",
    es: "Miedo a dejar una relación dañina",
  },
  days,
});

export default fearLeavingBadRelationshipBlueprintEn;
